const env = import.meta.env

export const SUPPORT_PHONE = env.VITE_SUPPORT_PHONE;
export const SUPPORT_TELEGRAM_CHAT_LINK = env.VITE_SUPPORT_TELEGRAM_CHAT_LINK;
export const SUPPORT_EMAIL = env.VITE_SUPPORT_EMAIL;
export const AVAILABLE_LOCALES = [
    { key: "uk", label: "Ua" },
    { key: "en", label: "Eng" },
];
